module.exports = __webpack_public_path__ + "img/avatar-s-19.908c8b78.png";